import React, {useEffect, useState} from 'react';
import { Button, Dialog } from '@alifd/next';
import homeStore from './store';
// import TextBox from './TextBox';
import GetHelp from './components/GetHelp';
import HCalendar from './components/HCalendar';
// import OrderRange from './components/orderRange';
import ParagraphTitle from './components/ParagraphTitle';
import moment from 'moment';
import utils from '../../common/utils';
import styles from './index.module.scss';
import DYCharts from './components/DYCharts';
import LoginDialog from './components/LoginDialog';

import DYOrderRange from './DY_components/DYOrderRange';
import DYShopSurvey from './DY_components/DYShopSurvey';
import DYAnnouncement from './DY_components/DYAnnouncement';
import DYMarketingNum from './DY_components/DYMarketingNum';
import SavePhoneNumber from './components/SavePhoneNumber';
import { Servlets } from '@/service';
import LzMessage from '@/components/common/LzMessage';

const {Provider} = homeStore;

const Home = () => {
  const [homeState, homeActions] = homeStore.useModel('default');
  const [dialogVisible, setDialogVisible] = useState(false);
  const [agreementContent, setAgreementContent] = useState({});
  const [agreementFlag, setAgreementFlag] = useState(false);
  const agreeSign = async () => {
    // if (item?.agreeTime) {
    //   // 如果签署过了
    //   setVisible(false);
    //   props.onClose && props.onClose();
    //   return;
    // }
    try {
      const res = await Servlets('signProtocol', {agreementId: agreementContent.agreementId});
      console.log(res);
      if (res.data) {
        LzMessage.success('签署成功!', '');
        setAgreementFlag(false);
      } else {
        LzMessage.error(`${res.resp_msg}`, '');
      }
    } catch (e) {
      LzMessage.error('签署失败', '');
      console.log(e)
    }
  }
  useEffect(() => {
    /** 设置Header面包屑 */
    utils.setBreadcrumb({name: '首页概览'});
    getNowM();
    getStoreInfo();

    Servlets('getProtocol', {}).then((res) => {
      if (res.data.agreementId) {
        setAgreementContent({...res.data});
        setAgreementFlag(true);
      } else {
        console.log('获取协议失败，请重试');
      }
    }).catch((e) => {
      console.log('获取协议失败，请重试');
    });
  }, []);

  // 格式化日期
  function formatDate(date) {
    date = new Date(date);
    const myyear = date.getFullYear();
    let mymonth = date.getMonth() + 1;
    let myweekday = date.getDate();
    mymonth < 10 ? mymonth = `0${mymonth}` : mymonth;
    myweekday < 10 ? myweekday = `0${myweekday}` : myweekday;
    return `${myyear}-${mymonth}-${myweekday}`;
  }

  // 获取当前月的天数
  function mGetDate() {
    const date = new Date();
    const year = date.getFullYear();
    const month = date.getMonth() + 1;
    const d = new Date(year, month, 0);
    return d.getDate();
  }

  function getNowM() {
    const now = new Date();
    const current_month_num = mGetDate();
    const current_month = [];
    for (let i = 1; i <= current_month_num; i++) {
      const day = now.setDate(i);
      const everyDay = formatDate(day);
      // @ts-ignore
      current_month.push(everyDay);
    }
    const starT = moment(current_month[0]).valueOf();
    const endT = moment(current_month[current_month.length - 1]).valueOf();
    homeActions.setState({startTime: starT, endTime: endT, calendar: 'month'});
    // homeActions.setState({startTime:"2020-06-11",endTime:"2020-06-17"})
  }

  /** 获取店铺基本信息 */
  const getStoreInfo = (): void => {
    Servlets("getTitle")
      .then((res: { data: { phone: ""; remainingDay: 0; shopName: ""; smsTotal: 0 } }) => {
        if(!res.data.phone) setDialogVisible(true)
      })
      .catch((err) => {
        console.log(err);
      });
  };
  return (
    <section style={{paddingTop: 30, marginLeft: 20, marginRight: 20, position: 'relative'}}>
      {/* 店铺概况 */}
      <DYShopSurvey/>
      <ParagraphTitle title="销售情况"/>
      <div className={styles.row_between} style={{marginBottom: 10}}>
        <DYOrderRange/>
        <DYCharts/>
      </div>
      <div className={styles.row_between}>
        <ParagraphTitle title="营销日历（短信）"/>
      </div>
      <div className={styles.row_between} style={{marginBottom: 10}}>
        <HCalendar type={homeState.calendar} startTime={homeState.startTime} endTime={homeState.endTime}/>
        <DYMarketingNum type={homeState.calendar} startTime={homeState.startTime} endTime={homeState.endTime}/>
      </div>
      <ParagraphTitle title="帮助&公告"/>
      <div className={styles.row_between}>
        <DYAnnouncement/>
        <GetHelp/>
      </div>
      {/* <AnnouncementPopup/> */}

      <LoginDialog />
      {dialogVisible && <SavePhoneNumber dialogVisible={dialogVisible} setDialogVisible={(v)=>{setDialogVisible(v)}}/>}

      {
        agreementFlag && <Dialog
          visible={agreementFlag}
          title={agreementContent.agreementTitle}
          width={1000}
          height={600}
          footer={<Button
              type='primary'
              onClick={()=>{
                agreeSign();
              }}
            >
              {/* {
                agreementContent?.agreeTime
                ? '我已知晓'
                :'同意签署'
              } */}
              同意签署
            </Button>
          }
          closeIcon={<span/>}
          closeable={false}
        >
          <div
            style={{
              // height: '465px',
              // width:'930px',
              // overflowY: 'auto',
              whiteSpace: 'pre',
            }}
          >
            <div dangerouslySetInnerHTML={{__html: agreementContent.agreementContent}}>
            </div>
          </div>
        </Dialog>
      }
    </section>
  );
};

export default (props) => {
  return <Provider><Home {...props} /></Provider>;
};
